module.exports = __webpack_public_path__ + "media/img/frontend_application/reward_bg-6832b8cad0fb415babe602372db00907.png";